import 'jquery-steps/build/jquery.steps';
import 'jquery-validation/dist/jquery.validate';

((
    ($) => {

        let _wizard = $("#wizard");
        let _saveFirstStepResult = false;
        let _otpDone = false;
        let _ajaxIsSending = false;

        var _form = $("#form_wizard");
        const _url = _form.attr('action');
        const _method = _form.attr('method');
        var _data = new FormData(_form[0]);
        var is_async_step = false;

        let _wizardSteps = _wizard.steps({
            headerTag: "h3",
            bodyTag: "section",
            transitionEffect: "fade",
            autoFocus: true,
            titleTemplate: '#index#',
            labels: {
                next: window.labels.next,
                finish: window.labels.finish
            },
            enableAllSteps: false,
            onStepChanging: function (event, currentIndex, newIndex) {
                console.log("onStepChanging-currentIndex", currentIndex)
                if (currentIndex > newIndex) {
                    return false;
                }
                if (currentIndex === 0 && newIndex === 1 && _saveFirstStepResult === false) {

                    _form.validate().settings.ignore = ":disabled,:hidden";

                    _form.valid();
                    var form = $("#form_wizard");
                    const _url = form.attr('action');
                    const _method = form.attr('method');
                    var formData = new FormData(form[0]);
                    $.ajax({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        url: _url,
                        method: _method,
                        data: formData,
                        cache: false,
                        dataType: 'json',
                        processData: false,
                        contentType: false,
                        async: false,
                    }).done((response) => {
                        if (response.success) {
                            _saveFirstStepResult = true;
                            console.log('must go now to next step');
                            _saveFirstStepResult = true;
                            $('.alert-danger').html("");
                            $('.alert-danger').hide();

                        } else {
                            return false;
                        }
                    }).fail((response) => {
                        $('.alert-danger').html('');
                        let errors = response.responseJSON.errors;
                        $.each(errors, function (key, value) {
                            console.log('value', value);
                            $('.alert-danger').show();
                            $('.alert-danger').append('<p>' + value + '</p>');
                        });
                        return false;
                    });
                }
                if (currentIndex === 0 && newIndex === 1 && _saveFirstStepResult === true) {
                    return true;
                }


                // if (currentIndex === 0 && _saveFirstStepResult === false && _form.valid()) {
                //     console.log("_saveFirstStepResult", _saveFirstStepResult);
                //     saveFirstStep();
                //     // return false;
                // }


                if (currentIndex === 1 && _otpDone === false) {
                    checkOTP();
                }
                if (currentIndex === 1 && _otpDone === true) {
                    return true;
                }

                if (newIndex === 2 && _otpDone === false) {
                    return false;
                }
                if (currentIndex === 2 && newIndex === 3) {

                  let branch=  $('#branch').val();
                    if(branch===''){
                        alert('الرجاء اختيار الفرع');
                    }
                    _form.validate().settings.ignore = ":disabled,:hidden";
                    return _form.valid();

                }
                if (newIndex === 3) {
                    _form.validate().settings.ignore = ":disabled,:hidden";
                    return _form.valid();
                    // return true;
                }

                // Forbid next action on "Warning" step if the user is to young
                if (newIndex === 4) {
                    _form.validate().settings.ignore = ":disabled,:hidden";
                    return _form.valid();
                    // return true;
                }
                // Needed in some cases if the user went back (clean up)
                if (currentIndex < newIndex) {
                    // To remove error styles
                    _form.find(".body:eq(" + newIndex + ") label.error").remove();
                    _form.find(".body:eq(" + newIndex + ") .error").removeClass("error");
                }
                // _form.validate().settings.ignore = ":disabled,:hidden";
                // return _form.valid();
            },
            onStepChanged: function (event, currentIndex, priorIndex) {
                // Used to skip the "Warning" step if the user is old enough.
                console.log("onStepChanged-onStepChanging-currentIndex", currentIndex);

                // if (currentIndex === 2) {
                //     _form.steps("next");
                // }
                // // Used to skip the "Warning" step if the user is old enough and wants to the previous step.
                // if (currentIndex === 2 && priorIndex === 3) {
                //     _form.steps("previous");
                // }

                // var seconds = 60;
                // var timer;
                //
                // function Timer() {
                //     if (seconds < 60) {
                //         document.getElementById("timer").innerHTML = seconds;
                //     }
                //     if (seconds > 0) {
                //         seconds--;
                //     } else {
                //         clearInterval(timer);
                //         location.reload();
                //     }
                // }
                //
                // if (!timer) {
                //     timer = window.setInterval(function () {
                //         Timer();
                //     }, 1000);
                // }
                //
                // document.getElementById("timer").innerHTML = "1:00";
            },
            onInit: function (event, currentIndex) {
                $('.actions > ul > li:first-child').attr('style', 'display:none');
                _wizard.closest('.lazyload-block').removeClass('lazyload-block');
                _form.stop().show();
            },
            onFinishing: function (event, currentIndex) {
                console.log("onFinishing");
                // _form.validate().settings.ignore = ":disabled";
                // return _form.valid();
                return true;
            },
            onFinished: function (event, currentIndex) {
                console.log('onFinished')
                const _url = "loan_form-submit/second_steps"
                const _method = _form.attr('method');
                const _data = _form.serialize();
                $('.alert-danger').html("");
                $('.alert-danger').hide("");

                $.ajax({
                    url: _url,
                    method: _method,
                    data: _data,
                }).done((response) => {
                    if (response.status) {
                        _form.closest('.closets-w').html(response.html);
                    }
                }).fail((response) => {
                    $.each(response.responseJSON.errors, function (key, value) {
                        $('.alert-danger').html("");
                        $('.alert-danger').show();
                        $('.alert-danger').append('<p>' + value + '</p>');
                    });
                    return false;
                }).always((response) => {
                    _ajaxIsSending = false;
                });
            }
        }).validate({});

        jQuery.extend(jQuery.validator.messages, {
            required: window.labels.required,
        });

        function saveFirstStep() {


            $.ajax({
                url: _url,
                method: _method,
                data: _data,
            }).done((response) => {
                if (response.success) {
                    _saveFirstStepResult = true;
                    console.log('must go now to next step');
                    _wizardSteps.steps("next");

                } else {
                    return false;
                }
                return true;
            }).fail((response) => {
                console.log(response);
                $.each(response.responseJSON.errors, function (key, value) {
                    console.log('value', value);
                    $('.alert-danger').html("");
                    $('.alert-danger').show();
                    $('.alert-danger').append('<p>' + value + '</p>');
                });
                _saveFirstStepResult = false;
            });
        }

        $(window).on('load', function () {
            wiz_dropdown();
        });

        function wiz_dropdown() {
            if ($('#project').length) {
                if (document.getElementById('project').checked) {
                    document.getElementById('projects').style.display = 'block';
                    document.getElementById('projects_type').style.display = 'block';
                } else {
                    document.getElementById('projects').style.display = 'none';
                    document.getElementById('projects_type').style.display = 'none';
                }
            }
        }

        function checkOTP() {
            const _url = "/loan_form-submit/otp"
            const _method = "POST"
            let code = $('#code').val();
            const _data = {code};
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: _url,
                method: _method,
                data: _data,
            }).done((response) => {
                if (response.success) {
                    _otpDone = true;
                    _wizard.steps("next", {});
                }
            }).fail((response) => {
                console.log(response);
                $("label.error").remove();
                $("#code").after('<label class="error">' + response.responseJSON.message + '</label>');
                _otpDone = false;
                return false;
            }).always((response) => {
                _ajaxIsSending = false;
                return false;
            });
        }
    }

)
(jQuery));

